<template>
  <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="data"
      :headers="headers"
      :items="usoSorted"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | date }}
    </template>
    <template v-slot:[`item.primoAccesso`]="{ item }">
      {{ item.primoAccesso | dateTime }}
    </template>
    <template v-slot:[`item.ultimoAccesso`]="{ item }">
      {{ item.ultimoAccesso | dateTime }}
    </template>        
    </v-data-table>
</template>

<script>
  import dispositivi from '@/services/dispositiviService.js'
  /* eslint-disable */
  export default {
    props: {
      item: Object,
      refresh: Number
    },
    data: () => ({
        selected: [],
        loading: false,
        options: {},
        headers: [
          { text: 'Data', value: 'data' },
          { text: 'Primo accesso', value: 'primoAccesso' },
          { text: 'Ultimo accesso', value: 'ultimoAccesso' },
          { text: 'Operatore', value: 'operatore' }
        ],      
        filtri: null,
        causali: [],
        uso: []
    }),
    watch: {
      async refresh() {
        await this.refreshData()
      }
    },
    computed: {
      usoSorted() {
        return _.sortBy(this.uso, ['data']).reverse()
      }
    },
    async mounted() {
      await this.refreshData()
    },
    methods: {
      async refreshData() {
        const associazione = this.item.associazioni.find(x => x.attivo)
        const codice = associazione ? associazione.codiceAssociazione : 'not found'
        this.uso = await dispositivi.getUsoDispositivo(codice)
      }
    }
  }
</script>
